export function sanitizeId(id) {
    if (id) {
        return id.replace(/_.*$/, '').replace('-', '');
    }
}
